import { FC } from 'react';
import { observer } from 'mobx-react';
import AppLayout from "modules/contacts/containers/Single/components/Layout";
import contactStore from 'stores/contact';
import Notes from 'submodules/notes/containers/index';


const ContactNotes: FC = observer(() => {
  const contact: any = contactStore.selected;

  return (
    <AppLayout>
      <Notes resource_type='Contact' resource={contact} />
    </AppLayout>
  );
})

export default ContactNotes;
